import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=486b7c8a&scoped=true"
import script from "./signup.vue?vue&type=script&lang=ts"
export * from "./signup.vue?vue&type=script&lang=ts"
import style0 from "./signup.vue?vue&type=style&index=0&id=486b7c8a&prod&lang=less&scoped=true"
import style1 from "./signup.vue?vue&type=style&index=1&id=486b7c8a&prod&lang=less"
import style2 from "./signup.vue?vue&type=style&index=2&id=486b7c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b7c8a",
  null
  
)

/* custom blocks */
import block0 from "./signup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports